export enum OrderEnum {
    OrderRelevance = 'orderRelevance',
    OrderNewest = 'orderNewest',
    OrderOldest = 'orderOldest'
}